import { render, staticRenderFns } from "./city-summary.vue?vue&type=template&id=2058dd54&scoped=true&"
import script from "./city-summary.js?vue&type=script&lang=js&"
export * from "./city-summary.js?vue&type=script&lang=js&"
import style0 from "./city-summary.scss?vue&type=style&index=0&id=2058dd54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058dd54",
  null
  
)

export default component.exports